import Contact from 'components/Layout/Header/Contact/Contact';
import { HEADER_TEST_IDENTIFIER, HeaderProps } from 'components/Layout/Header/Header';
import { HeaderBottom } from 'components/Layout/Header/HeaderBottom/HeaderBottom';
import HeaderLinks from 'components/Layout/Header/HeaderTop/HeaderLinks/HeaderLinks';
import { CompanyLogo } from 'components/Layout/Header/HeaderTop/Logo/CompanyLogo';
import useTranslation from 'next-translate/useTranslation';
import { memo } from 'react';

export const B2cHeader = memo<HeaderProps>(({ simple }) => {
    const { t } = useTranslation();

    return (
        <div className="vl:menu-gradient relative z-menu mb-5 bg-primary" data-testid={HEADER_TEST_IDENTIFIER}>
            <div className="flex w-full flex-wrap justify-between vl:px-5 xl:mx-auto xl:w-layout">
                <div className="flex h-11 flex-1 items-center justify-between vl:h-16 vl:shrink-0 vl:grow vl:basis-full">
                    <CompanyLogo linkText={t('Go to homepage')} />
                    {simple ? <Contact textColor="text-white" /> : <HeaderLinks />}
                </div>
                {!simple && <HeaderBottom />}
            </div>
        </div>
    );
});

B2cHeader.displayName = 'B2cHeader';
